export default {
  viewReport: '报告',
  viewHistory: '历史',
  registerNo: 'Register No',
  revNo: 'Rev No',
  hospitalLabNo: 'Hospital Lab No',
  pathoNo: 'Patho No',
  prefix: '字首',
  name: '患者姓名',
  hn: 'HN',
  physicianName: 'Physician Name',
  customer: '顾客',
  receivedDate: '收到日期',
  dateReported: '报告日期',
  dueDate: 'Due Date',
  tat: 'Turn Around Time',
  labelDateFrom: 'Receive Date From',
  labelDateTo: 'Receive Date To',
  labelBtnFind: '找',
  labelPathoPendingList: 'Pathologist Pending Report',
  labelPathoCompleteList: 'Pathologist Complete Report',
  labelPathoHistory: 'Pathology History Report',
}
